module.exports = __webpack_public_path__ + "font_darts.df8b29c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/font_darts.png
// module id = Kyp1
// module chunks = 0